<div
  id="workoutCalendarModal"
  #workoutCalendarModal
  class="modal"
  tabindex="-1"
>
  <div class="d-flex justify-content-center align-items-center">
    <div class="modal-dialog modal-fullscreen" style="width: 70%">
      <div class="modal-content">
        <div class="modal-header">
          <i
            *ngIf="modalShow == 'workout'"
            class="bi bi-arrow-left"
            (click)="handleBackButtonClick()"
            style="cursor: pointer; margin-right: 10px"
          ></i>
          <h2>Calendario de rutina</h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="p-4" *ngIf="modalShow == 'calendar'">
            <full-calendar
              #calendar
              [options]="calendarOptions"
              class="w-100 h-100 z-3"
            ></full-calendar>
          </div>

          <div
            class="p-4"
            *ngIf="modalShow == 'workout'"
            (ngIfChange)="onModalShowChange('workout')"
          >
            <app-workout-detail></app-workout-detail>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
